import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=out, object=in

  useEffect(() => {
    const t = localStorage.getItem("sd_token");
    if (!t) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("sd_token"); setUser(false); });
  }, []);

  const login = (token, u) => { localStorage.setItem("sd_token", token); setUser(u); };
  const logout = () => { localStorage.removeItem("sd_token"); setUser(false); };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};
